import ecRetention from '../../consts/experienceScore/ecRetention';
import ecPushRecommendationTypes from '../../consts/notification/ecPushRecommendationTypes';
import storageService from '../storageService';

const EC_SUBTYPE_PREFIX = 'EXP_COACH_';

const isEcSubType = (notificationSubType) => Boolean(notificationSubType?.startsWith(EC_SUBTYPE_PREFIX));

const getRecommendationType = (notificationSubType) => ecPushRecommendationTypes[notificationSubType] || null;

const isExpired = (receivedAt) => !receivedAt || Date.now() - receivedAt > ecRetention.PUSH_MS;

const close = (recommendationType) => {
    const pushes = storageService.getEcPushes();

    if (!pushes[recommendationType]) return;

    delete pushes[recommendationType];

    storageService.setEcPushes(pushes);
};

const add = ({messageId, notificationSubType}) => {
    const recommendationType = getRecommendationType(notificationSubType);

    if (!messageId || !recommendationType) return;

    storageService.setEcPushes({
        ...storageService.getEcPushes(),
        [recommendationType]: {messageId, receivedAt: Date.now()},
    });
};

const resolve = (recommendationType) => {
    if (!recommendationType) return null;

    const push = storageService.getEcPushes()[recommendationType];

    if (!push) return null;

    if (isExpired(push.receivedAt)) {
        close(recommendationType);

        return null;
    }

    return push.messageId;
};

export default {
    isEcSubType,
    getRecommendationType,
    add,
    resolve,
    close,
};
